import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Box, Typography, Stack, Drawer, Link, Collapse } from "@mui/material";
import { classes } from "./MessageList";
import three_dots from "../../../assets/images/chats/three_dots.svg";
import starred_icon from "../../../assets/images/chats/starred_icon.svg";
import unstar_icon from "../../../assets/images/chats/unstar_icon.svg";
import replaym from "../../../assets/images/chats/reply.svg";
import moment from "moment";
import MoreMenu from "./MoreMenu";
import InputDialogComponent from "../../../components/InputDialog";
import PersonIcon from "../../../assets/images/chats/person.svg";
import RecipientList from "./RecipientList";
import { getFileIconUrl } from "../../../utils/findextension";
import {
  AccountLevelArkchatPermission,
  ApprovalStatus,
  MessageType,
  TaskStatus,
  priorityValueColor,
  priorityValueLable,
  getTaskStatusLabels,
} from "../../../utils/constant";
import StartTask from "./StartTask";
import { useTranslation } from "react-i18next";
import HandleLink from "./HandleLink";
import {
  colorSchemes,
  personIconStyle,
} from "../../../assets/commonFunction";
import TaskStatusButton from "../../../components/TaskStatusButton/TaskStatusButton";
import session, { showUpdateTaskButton } from "../../../utils/helper";
import useAppSelectors from "../../../customHooks/useAppSelectors";
const MessageThread = ({
  item,
  isMoreMenuOpen,
  startTaskOpen,
  setStartTaskOpen,
  handleStartTask,
  threeDotRef,
  isDeleteGroupMsgOpenIndicatorId,
  isDeleteGroupMsgOpen,
  handleReadStatusDrawer,
  setisTopicOpen,
  setMoveTopicMsgId,
  setMoveTopicTriggered,
  setDeleteGroupMsgOpenIndicatorId,
  setDeleteGroupMsgOpen,
  handlegetThreadMessages,
  setMoreMenu,
  menuRef,
  toggleItemMenu,
  localStarMsgData,
  handleStarUnstarMsg,
  handleDeleteGrpMsg,
  setDeleteGrpMsgType,
  handleClickTaskUpdate,
  handleShowUserProfile,
  bgcolor,
  scrollToRepliedMessage,
  hideBottonLine = false,
}) => {
  const { t } = useTranslation();
  const appConstant = t("AppConstant", { returnObjects: true });
  const appContent = t("AppContent", { returnObjects: true });
  const taskStatusLabels = getTaskStatusLabels(appConstant);
  const { selectedGroup, groupTopicData, groupRecipientDetails, currentUserData} = useAppSelectors();
  const [isRecipientListOpen, setRecipientListOpen] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [recipientList, setRecipientList] = useState([]);
  const isThreadScreen = session.get("isThreadScreen");

  const handleSeeRecipientList = (recipientData) => {
    setRecipientList(recipientData);
    setRecipientListOpen(true);
  };
  return (
    <>
      <Drawer
        sx={{
          zIndex: 12011,
        }}
        hideBackdrop={true}
        anchor={"right"}
        open={isRecipientListOpen}
      >
        <RecipientList
          recipientList={recipientList}
          readby={item?.read_by}
          setRecipientListOpen={setRecipientListOpen}
          handleShowUserProfile={handleShowUserProfile}
        />
      </Drawer>
      <Box key={item?.timetoken}>
        <Box width={"100%"}>
          {(item?.type === 0 ||
            item?.type === 3 ||
            item?.type === 1 ||
            item?.type === 2) && (
            <>
              <Stack
                direction="row"
                width={"100%"}
                padding={"0.8rem 0rem"}
                justifyContent={"space-between"}
                bgcolor={bgcolor}
                id={`replied-message-${item?.temp_timetoken}`}
              >
                <div style={{ width: "100%" }}>
                  <Stack
                    width={"100%"}
                    direction="row"
                    spacing={1}
                  >
                    {/* ------------profile section--------------- */}
                    {item?.from?.pp ? (
                      <Box
                        onClick={() => handleShowUserProfile(item?.from?.id)}
                        sx={{ ...classes.chatUserprofile, cursor: "pointer" }}
                      >
                        <img src={item?.from?.pp} alt="profile" height="100%" />
                      </Box>
                    ) : (
                      <Box
                        sx={{ cursor: "pointer" }}
                        onClick={() => handleShowUserProfile(item?.from?.id)}
                        bgcolor={"#E3E1E1"}
                        width={"30px"}
                        height={"30px"}
                        display={"flex"}
                        flex={"none"}
                        alignItems={"center"}
                        flex-wrap={"wrap"}
                        justifyContent={"center"}
                        borderRadius={"0.15rem"}
                        // border={"1px solid blue"}
                      >
                        <img
                          style={personIconStyle}
                          src={PersonIcon}
                          alt="individual"
                        />
                        {/* <Typography variant="h6" fontSize={"0.75rem"}>
                          {item?.from?.name && item?.from?.name[0]}
                        </Typography> */}
                      </Box>
                    )}
                    {/* ------------Details section--------------- */}
                    <Box width={"100%"} paddingRight={2}>
                      <Stack
                        direction="row"
                        spacing={1}
                        width={"100%"}
                        justifyContent={"space-between"}
                      >
                        <Box
                          sx={{ width: "89%", display: "flex" }}
                        >
                          <Typography variant="subtitle2" fontWeight={"450"}>
                            {item?.from?.name}
                          </Typography>
                          <Typography
                            sx={{ ...classes.duetime, marginLeft: "0.5rem" }}
                          >
                            {/* Time */}
                            {moment(Math.floor(item?.timetoken / 10000)).format(
                              currentUserData?.timeFormat === "24"
                                ? currentUserData
                                    ?.userDateTimeFormat
                                : currentUserData
                                    ?.userDateTimeFormat
                            )}
                          </Typography>
                        </Box>
                        {/* ------------Right section--------------- */}
                        <Box>
                          <Stack
                            spacing={2}
                            direction="row"
                            alignItems={"center"}
                          >
                            <Box position={"relative"}>
                              <Box
                                ref={threeDotRef}
                                onClick={() => toggleItemMenu(item)}
                                sx={{
                                  cursor: "pointer",
                                  pointerEvents: isMoreMenuOpen ? "none" : "",
                                }}
                              >
                                <img src={three_dots} alt="more" />
                              </Box>
                              {isMoreMenuOpen?.timetoken ===
                                item?.timetoken && (
                                <MoreMenu
                                  selectedGroup={selectedGroup}
                                  isThreadScreen={isThreadScreen}
                                  menuRef={menuRef}
                                  messageData={item}
                                  setMoreMenu={setMoreMenu}
                                  isStarred={item?.isStarred}
                                  handleReplyMessage={handlegetThreadMessages}
                                  setDeleteGroupMsgOpen={setDeleteGroupMsgOpen}
                                  setDeleteGroupMsgOpenIndicatorId={
                                    setDeleteGroupMsgOpenIndicatorId
                                  }
                                  setMoveTopicTriggered={setMoveTopicTriggered}
                                  setMoveTopicMsgId={setMoveTopicMsgId}
                                  setisTopicOpen={setisTopicOpen}
                                  handleReadStatusDrawer={
                                    handleReadStatusDrawer
                                  }
                                />
                              )}
                              <>
                                {isDeleteGroupMsgOpen &&
                                  isDeleteGroupMsgOpenIndicatorId ===
                                    item?.timetoken && (
                                    <InputDialogComponent
                                      title="Delete"
                                      isType="deletegroupmessage"
                                      open={isDeleteGroupMsgOpen}
                                      handleClose={() => {
                                        setDeleteGroupMsgOpen(false);
                                        setDeleteGroupMsgOpenIndicatorId(null);
                                      }}
                                      btnLabel="Delete"
                                      setDeleteGrpMsgType={setDeleteGrpMsgType}
                                      onClick={() => handleDeleteGrpMsg(item)}
                                      isallowedDeleteGrpMsgForall={
                                        (currentUserData?.id ===
                                          item?.from?.id ||
                                          currentUserData
                                            ?.activePermission ===
                                            AccountLevelArkchatPermission?.ADMIN) &&
                                        moment().diff(
                                          Math.floor(item?.timetoken / 10000),
                                          "minutes"
                                        ) <= 30
                                          ? false
                                          : true
                                      }
                                    />
                                  )}
                              </>
                            </Box>

                            <Box
                              onClick={() =>
                                handleStarUnstarMsg(
                                  item?.timetoken,
                                  item?.starred_by
                                )
                              }
                              sx={{
                                cursor: "pointer",
                                width: "16px",
                              }}
                            >
                              <img
                                width={"100%"}
                                height={"100%"}
                                src={
                                  (item?.starred_by &&
                                    item?.starred_by?.includes(
                                      currentUserData?.id
                                    )) ||
                                  localStarMsgData?.includes(item?.timetoken)
                                    ? starred_icon
                                    : unstar_icon
                                }
                                alt="more"
                              />
                            </Box>
                          </Stack>
                        </Box>
                        {/* ------------------------------------------ */}

                        {/* <Box sx={classes.tick}>
                        <img src={tick_gray} alt="Chat Status" />
                      </Box> */}
                      </Stack>
                      <Typography
                        onClick={() => handleSeeRecipientList(item?.to)}
                        variant="subtitle2"
                        display={"inline-block"}
                        sx={classes.userlink}
                      >
                        {item?.is_all_group_member
                          ? "To all group members"
                          : `To ${item?.to[0]?.name}${
                              item?.to?.length > 1
                                ? `, and ${item?.to?.length - 1} more`
                                : ""
                            }`}
                      </Typography>

                      {/* -------------reply---------- */}
                      {item?.thread_original_message &&
                        item?.translations &&
                        item?.thread_original_message?.translations && (
                          <Stack
                            direction="row"
                            width={"100%"}
                            spacing={1}
                            sx={{ ...classes.chatRep, cursor: "pointer" }}
                            onClick={() =>
                              scrollToRepliedMessage(
                                item?.thread_original_message?.temp_timetoken
                              )
                            }
                          >
                            <img src={replaym} alt="reply" />
                            {item?.translations &&
                            item?.thread_original_message?.translations[
                              item?.to?.find(
                                (data) =>
                                  data?.id === currentUserData?.id
                              )?.languageCode
                            ] ? (
                              <Typography
                                variant="body2"
                                sx={{
                                  wordWrap: "break-word",
                                }}
                              >
                                {item?.to?.findIndex(
                                  (idData) =>
                                    idData?.id ===
                                    currentUserData?.id
                                ) !== -1 &&
                                  item?.thread_original_message?.translations[
                                    item?.to?.find(
                                      (data) =>
                                        data?.id ===
                                        currentUserData?.id
                                    )?.languageCode
                                  ]?.slice(0, 200) + " ..."}
                              </Typography>
                            ) : (
                              <Typography
                                variant="body2"
                                sx={{
                                  wordWrap: "break-word",
                                }}
                              >
                                {item?.to?.findIndex(
                                  (idData) =>
                                    idData?.id ===
                                    currentUserData?.id
                                ) !== -1 &&
                                  item?.thread_original_message?.message?.slice(
                                    0,
                                    200
                                  ) + " ..."}
                              </Typography>
                            )}
                          </Stack>
                        )}

                      {/* text message */}
                      <Box width={"100%"}>
                        <HandleLink>
                          {item?.translations &&
                          item?.translations[
                            item?.to?.find(
                              (data) =>
                                data?.id === currentUserData?.id
                            )?.languageCode
                          ] ? (
                            <Typography
                              sx={{ wordWrap: "break-word" }}
                              width={"100%"}
                              variant="body2"
                            >
                              {!expanded &&
                                item?.to?.findIndex(
                                  (idData) =>
                                    idData?.id ===
                                    currentUserData?.id
                                ) !== -1 &&
                                item?.translations[
                                  item?.to?.find(
                                    (data) =>
                                      data?.id ===
                                      currentUserData?.id
                                  )?.languageCode
                                ]
                                  ?.slice(0, 200)
                                  ?.split(/\n/)
                                  ?.map((line, indx) => (
                                    <span
                                      key={line + indx + "xyz007"}
                                      style={{
                                        marginBottom: "0.5rem",
                                        display: "block",
                                        border:
                                          line === ""
                                            ? "1px solid transparent"
                                            : "none",
                                      }}
                                    >
                                      <>{line === "" ? " " : line}</>
                                    </span>
                                  ))}{" "}
                              {!expanded &&
                              item?.translations[
                                item?.to?.find(
                                  (data) =>
                                    data?.id === currentUserData?.id
                                )?.languageCode
                              ]?.length > 200
                                ? " ..."
                                : ""}
                              <Collapse
                                sx={{ wordWrap: "break-word" }}
                                in={expanded}
                                timeout="auto"
                                unmountOnExit
                              >
                                {item?.to?.findIndex(
                                  (idData) =>
                                    idData?.id ===
                                    currentUserData?.id
                                ) !== -1 &&
                                  item?.translations[
                                    item?.to?.find(
                                      (data) =>
                                        data?.id ===
                                        currentUserData?.id
                                    )?.languageCode
                                  ]
                                    ?.split(/\n/)
                                    ?.map((line, indx) => (
                                      <span
                                        key={line + indx + "xyz008"}
                                        style={{
                                          marginBottom: "0.5rem",
                                          display: "block",
                                          border:
                                            line === ""
                                              ? "1px solid transparent"
                                              : "none",
                                        }}
                                      >
                                        <>{line === "" ? " " : line}</>
                                      </span>
                                    ))}
                              </Collapse>
                              {item?.translations[
                                item?.to?.find(
                                  (data) =>
                                    data?.id === currentUserData?.id
                                )?.languageCode
                              ]?.length > 200 && (
                                <Typography
                                  variant="body2"
                                  width={"100%"}
                                  expand={expanded}
                                  onClick={() => setExpanded(!expanded)}
                                  aria-expanded={expanded}
                                  aria-label="show more"
                                  sx={{
                                    textDecoration: "underline",
                                    cursor: "pointer",
                                  }}
                                  display={"inline"}
                                  color={"#2C86FF"}
                                >
                                  {expanded ? "less" : "more"}
                                </Typography>
                              )}
                            </Typography>
                          ) : (
                            <Typography
                              sx={{ wordWrap: "break-word" }}
                              width={"100%"}
                              variant="body2"
                            >
                              {!expanded &&
                                item?.to?.findIndex(
                                  (idData) =>
                                    idData?.id ===
                                    currentUserData?.id
                                ) !== 1 &&
                                item?.message?.slice(0, 200) +
                                  (item?.message?.length > 200 ? " ..." : "")}
                              <Collapse
                                in={expanded}
                                timeout="auto"
                                unmountOnExit
                              >
                                {item?.to?.findIndex(
                                  (idData) =>
                                    idData?.id ===
                                    currentUserData?.id
                                ) !== 1 &&
                                  item?.message
                                    ?.split(/\n/)
                                    .map((line, indx) => (
                                      <span
                                        key={line + indx + "xyz009"}
                                        style={{
                                          marginBottom: "0.5rem",
                                          display: "block",
                                          border:
                                            line === ""
                                              ? "1px solid transparent"
                                              : "none",
                                        }}
                                      >
                                        {line}
                                      </span>
                                    ))}
                              </Collapse>

                              {item?.message?.length > 200 && (
                                <Typography
                                  variant="body2"
                                  width={"100%"}
                                  expand={expanded}
                                  onClick={() => setExpanded(!expanded)}
                                  aria-expanded={expanded}
                                  aria-label="show more"
                                  sx={{
                                    textDecoration: "underline",
                                    cursor: "pointer",
                                  }}
                                  display={"inline"}
                                  color={"#2C86FF"}
                                >
                                  {expanded ? "less" : "more"}
                                </Typography>
                              )}
                            </Typography>
                          )}
                        </HandleLink>
                      </Box>
                      {/* -----------------subUser details------------------ */}
                      {item?.type !== 0 && item?.type != 3 && (
                        <>
                          <Stack
                            mt={"0.8rem"}
                            direction="row"
                            spacing={1}
                            gap={"2.5rem"}
                            width={"100%"}
                            justifyContent={"space-between"}
                          >
                            <Stack
                              width={"90%"}
                              alignItems={"center"}
                              direction="row"
                              spacing={1}
                            >
                              {item?.assignee?.pp ? (
                                <Box
                                  onClick={() =>
                                    handleShowUserProfile(item?.assignee?.id)
                                  }
                                  sx={{
                                    ...classes.chatUserprofile,
                                    cursor: "pointer",
                                  }}
                                >
                                  <img
                                    src={item?.assignee?.pp}
                                    alt="profile"
                                    height="100%"
                                  />
                                </Box>
                              ) : (
                                <Box
                                  sx={{ cursor: "pointer" }}
                                  bgcolor={"#E3E1E1"}
                                  width={"27px"}
                                  height={"27px"}
                                  display={"flex"}
                                  flex={"none"}
                                  alignItems={"center"}
                                  flex-wrap={"wrap"}
                                  justifyContent={"center"}
                                  borderRadius={"0.15rem"}
                                  onClick={() =>
                                    handleShowUserProfile(item?.assignee?.id)
                                  }
                                >
                                  <Typography variant="h6" fontSize={"0.75rem"}>
                                    {item?.assignee?.name &&
                                      item?.assignee?.name[0]}
                                  </Typography>
                                </Box>
                              )}
                              <Box>
                                <Box sx={classes.userInfo}>
                                  <Stack
                                    direction="row"
                                    spacing={1}
                                    flexDirection={"row"}
                                    alignItems={"center"}
                                  >
                                    <Typography
                                      variant="subtitle2"
                                      fontWeight={"400"}
                                      fontSize={"0.75rem"}
                                    >
                                      {item?.type === MessageType?.Approval
                                        ? "Approval"
                                        : item?.is_main?"Task":"Subtask"}{" "}
                                      : {item?.assignee?.name}
                                    </Typography>
                                    {/* Pending Button */}
                                    <TaskStatusButton
                                      item={item}
                                      status="approval"
                                    />
                                    <TaskStatusButton
                                      item={item}
                                      status="task"
                                    />
                                  </Stack>
                                </Box>
                              </Box>
                            </Stack>
                          </Stack>

                          <Box display={"flex"}>
                            <Box
                              width="75%"
                              ml={"2.18rem"}
                              display={"flex"}
                              gap={"0.2rem"}
                              flexDirection={"column"}
                            >
                              <Typography
                                variant="subtitle2"
                                fontSize={"0.75rem"}
                                lineHeight={"15px"}
                              >
                                {item?.type === MessageType?.Approval
                                  ? appContent?.KEY343
                                  : appContent?.KEY342}{" "}
                                :{" "}
                                {moment(
                                  Math.floor(item?.timetoken / 10000)
                                ).format(
                                  currentUserData?.userDateFormat
                                )}
                              </Typography>

                              <Typography
                                variant="subtitle2"
                                lineHeight={"15px"}
                                fontSize={"0.75rem"}
                              >
                                {" "}
                                Due on :{" "}
                                {moment(item?.due_date).format(
                                  currentUserData?.userDateFormat
                                )}{" "}
                                {moment(item?.due_time, "HH:mm").format(
                                  currentUserData?.userTimeFormat
                                )}
                              </Typography>

                              <Box>
                                <Typography
                                  variant="subtitle2"
                                  fontSize={"0.75rem"}
                                  lineHeight={"15px"}
                                >
                                  {item?.type === MessageType?.Task
                                    ? "Task"
                                    : "Approval"}{" "}
                                  Priority :
                                  <span
                                    style={{
                                      display: "inline-block",
                                      width: "13px",
                                      height: "13px",
                                      verticalAlign: "middle",
                                      margin: "-1px 5px 0px 5px",
                                      backgroundColor:
                                        priorityValueColor[item?.priority],
                                    }}
                                  ></span>
                                  {priorityValueLable[item?.priority]}
                                </Typography>
                              </Box>

                              {item?.start_time > 0 && (
                                <>
                                  <Typography
                                    variant="subtitle2"
                                    fontSize={"0.75rem"}
                                    lineHeight={"15px"}
                                  >
                                    Started :{" "}
                                    {moment
                                      .unix(item?.start_time)
                                      .format(
                                        currentUserData
                                          ?.userDateFormat
                                      )}
                                  </Typography>
                                </>
                              )}

                              {item?.end_time > 0 && (
                                <>
                                  <Typography
                                    variant="subtitle2"
                                    fontSize={"0.75rem"}
                                    lineHeight={"15px"}
                                  >
                                    Finished :{" "}
                                    {moment
                                      .unix(item?.end_time)
                                      .format(
                                        currentUserData
                                          ?.userDateFormat
                                      )}
                                  </Typography>
                                </>
                              )}
                              {item?.estimated_time?.timeValue && (
                                <>
                                  <Typography
                                    variant="subtitle2"
                                    fontSize={"0.75rem"}
                                    lineHeight={"15px"}
                                  >
                                    Estimated time :{" "}
                                    {item?.estimated_time?.timeValue}{" "}
                                    {item?.estimated_time?.timeType}
                                  </Typography>

                                  {item?.actual_time?.timeValue && (
                                    <>
                                      <Typography
                                        variant="subtitle2"
                                        fontSize={"0.75rem"}
                                        lineHeight={"15px"}
                                      >
                                        Actual Time :{" "}
                                        {item?.actual_time?.timeValue}{" "}
                                        {item?.actual_time?.timeType}
                                      </Typography>
                                    </>
                                  )}
                                </>
                              )}
                              {item?.estimated_time?.timeValue && (
                                <Box>
                                  {item?.end_time > 0 && (
                                    <>
                                      <Typography
                                        color={
                                          item?.actual_time?.timeValue <
                                            item?.estimated_time?.timeValue ||
                                          Math.abs(
                                            item?.diff_time?.timeValue
                                          ) === 0
                                            ? "#007F8F"
                                            : "#DB0011"
                                        }
                                        fontSize={"0.75rem"}
                                      >
                                        {Math.abs(item?.diff_time?.timeValue) >
                                        0 ? (
                                          <>
                                            {Math.abs(
                                              item?.diff_time?.timeValue
                                            )}{" "}
                                            {item?.diff_time?.timeType}{" "}
                                            {item?.actual_time?.timeValue <
                                            item?.estimated_time?.timeValue
                                              ? "Less"
                                              : "More"}
                                          </>
                                        ) : (
                                          <>{appContent?.KEY270}</>
                                        )}
                                      </Typography>
                                    </>
                                  )}
                                </Box>
                              )}
                            </Box>

                            <Stack width='22%' direction="column" spacing={1}>
                              {item?.type === MessageType?.Approval && (
                                <>
                                  {(item?.from?.id ===
                                    currentUserData?.id ||
                                    item?.assignee?.id ===
                                      currentUserData?.id) &&
                                    item?.approval_status !==
                                      ApprovalStatus?.Approved &&
                                    item?.approval_status !==
                                      ApprovalStatus?.Rejected &&
                                    item?.approval_status !==
                                      ApprovalStatus?.Cancelled && (
                                      <Stack
                                        direction="row"
                                        sx={{
                                          ...classes.pendingT,
                                          cursor: "pointer",
                                          padding: "0.5rem 0.5rem",
                                          justifyContent: "center",
                                          alignItems: "center",
                                          border: "1px solid #000000",
                                        }}
                                        color={"#fff"}
                                        // bgcolor={"#DB0011"}
                                        onClick={() =>
                                          handleClickTaskUpdate(item)
                                        }
                                      >
                                        <Typography
                                          sx={{
                                            ...classes.txt,
                                            color: colorSchemes.black,
                                          }}
                                        >
                                          {" "}
                                          Update{" "}
                                        </Typography>
                                      </Stack>
                                    )}
                                </>
                              )}
                              {item?.type === MessageType?.Task && (
                                <>
                                  {/* <Box
                                    display={"flex"}
                                    sx={{
                                      ...classes.pendingT,
                                      cursor: "pointer",
                                      padding: "0.5rem 0.5rem",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                    color={"#fff"}

                                    
                                  >
                                    <Box display={"flex"} alignItems={"center"}>
                                    
                                    </Box>
                                    <Typography sx={classes.txt}>
                                      {" "}
                                      {taskStatusLabels[item?.task_status]}{" "}
                                    </Typography>
                                  </Box> */}

                                  {item?.assignee?.id ===
                                    currentUserData?.id &&
                                    (item?.task_status ===
                                      TaskStatus?.Pending ||
                                      item?.task_status ===
                                        TaskStatus?.Delayed) && (
                                      <Stack
                                        direction="row"
                                        position={"relative"}
                                        sx={{
                                          ...classes.pendingT,
                                          cursor: "pointer",
                                          padding: "0.5rem 0.5rem",
                                          justifyContent: "center",
                                          alignItems: "center",
                                          border: "1px solid #000000",
                                        }}
                                        color={"#fff"}
                                        //bgcolor={"#fff"}
                                        onClick={() => handleStartTask(item)}
                                      >
                                        {startTaskOpen?.timetoken ===
                                          item?.timetoken && (
                                          <StartTask
                                            open={
                                              startTaskOpen?.timetoken ===
                                              item?.timetoken
                                            }
                                            taskData={item}
                                            setStartTaskOpen={setStartTaskOpen}
                                          />
                                        )}
                                        {/* <Box
                                          display={"flex"}
                                          alignItems={"center"}
                                        >
                                          <TaskSvg
                                            circleColor={"#fff"}
                                            tickColor={"#fff"}
                                          />
                                        </Box> */}
                                        <Typography sx={classes.txt}>
                                          {" "}
                                          Start task{" "}
                                        </Typography>
                                      </Stack>
                                    )}
                                  {(showUpdateTaskButton(currentUserData,item,groupRecipientDetails)) && (
                                    <Stack
                                      direction="row"
                                      sx={{
                                        ...classes.pendingT,
                                        cursor: "pointer",
                                        padding: "0.5rem 0.5rem",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        border: "1px solid #000000",
                                      }}
                                      color={"#fff"}
                                      bgcolor={"#fff"}
                                      onClick={() =>
                                        handleClickTaskUpdate(item)
                                      }
                                    >
                                      <Typography
                                        sx={{
                                          ...classes.txt,
                                          color: colorSchemes.black,
                                        }}
                                      >
                                        {" "}
                                        Update{" "}
                                      </Typography>
                                    </Stack>
                                  )}
                                </>
                              )}
                            </Stack>
                          </Box>
                        </>
                      )}

                      {/* -----------------Attachments------------------ */}
                      {item?.attachments?.length > 0 && (
                        <Box mt={"0.5rem"}>
                          {item?.attachments?.map((fileData) => (
                            <Link
                              href={fileData?.location}
                              underline="none"
                              target="_blank"
                              rel="noopener"
                              color={"black"}
                              key={fileData?.location}
                            >
                              {" "}
                              <Box
                                display={"flex"}
                                alignItems={"center"}
                                gap={"0.2rem"}
                                // bgcolor={"#F3F3F3"}
                              >
                                <img
                                  style={{ height: "25px", width: "25px" }}
                                  src={getFileIconUrl(fileData?.location)}
                                  alt={fileData?.name}
                                />
                                <Typography
                                  variant="subtitle2"
                                  fontWeight={"400"}
                                  fontSize={"0.75rem"}
                                >
                                  {fileData?.name}
                                </Typography>
                              </Box>
                            </Link>
                          ))}
                        </Box>
                      )}

                      {/* Which Topic */}
                      <Stack
                        direction="row"
                        ml={item?.type === MessageType?.Message ? 0 : "2.18rem"}
                        alignItems={"center"}
                        sx={{ flexWrap: "nowrap", overflow: "hidden" }}
                      >
                        <Box
                          display={"flex"}
                          gap={"0.2rem"}
                          alignItems={"center"}
                          pr={1}
                          sx={{ flexShrink: 0 }}
                        >
                          <Typography fontSize={"0.75rem"}>Topic : </Typography>
                          <Typography
                            title={
                              groupTopicData?.data?.length > 0 &&
                              groupTopicData?.data?.find(
                                (data) => data?.id === item?.topic_id
                              )?.name
                            }
                            sx={{
                              ...classes.userlink2,
                              maxWidth: "100%",
                            }}
                          >
                            {groupTopicData?.data?.length > 0 &&
                              (() => {
                                const name = groupTopicData?.data?.find(
                                  (data) => data?.id === item?.topic_id
                                )?.name;
                                return name?.length > 80
                                  ? name.substring(0, 80) + "..."
                                  : name;
                              })()}
                          </Typography>{" "}
                        </Box>
                      </Stack>
                    </Box>
                  </Stack>
                </div>
              </Stack>
              {!hideBottonLine && (
                <Box
                  width={"100%"}
                  margin={"auto"}
                  border={"1px solid #ECECEC"}
                ></Box>
              )}
            </>
          )}
        </Box>
      </Box>
    </>
  );
};

export default MessageThread;
